<template>
  <div
    v-if="element.label?.trim()?.length"
    class="form-textblock-element-wrapper"
  >
    <p
      :style="textStyle"
      :id="`textblock-${element.id}`"
      class="form-textblock w-100 bg-transparent m-0 p-0 d-flex align-items-end justify-content-start"
    >
      {{ element.label }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FormTextblockElement',
  props: {
    element: {
      type: Object,
      required: true,
    },
    textStyle: { type: Object, default: () => {} },
  },
};
</script>

<style scoped>
.form-textblock-element-wrapper .form-textblock {
  font-family: 'OpenSans-Regular';
  font-weight: 400;
  letter-spacing: -0.02em;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  word-break: break-word;
}
</style>
